import { render, staticRenderFns } from "./CollapsibleTableSubsection.vue?vue&type=template&id=a978877a"
import script from "./CollapsibleTableSubsection.vue?vue&type=script&lang=js"
export * from "./CollapsibleTableSubsection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports